import React from 'react'
import createIcon from '@/lib/create-icon'

export const EyeSVGIcon = createIcon(
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_1118_2227)">
      <path d="M0.666504 7.99996C0.666504 7.99996 3.33317 2.66663 7.99984 2.66663C12.6665 2.66663 15.3332 7.99996 15.3332 7.99996C15.3332 7.99996 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 7.99996 0.666504 7.99996Z" stroke="currentColor" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M7.99984 9.99996C9.10441 9.99996 9.99984 9.10453 9.99984 7.99996C9.99984 6.89539 9.10441 5.99996 7.99984 5.99996C6.89527 5.99996 5.99984 6.89539 5.99984 7.99996C5.99984 9.10453 6.89527 9.99996 7.99984 9.99996Z" stroke="currentColor" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_1118_2227">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>,
)
